export var Collision;
(function (Collision) {
    Collision["fit"] = "fit";
    Collision["flip"] = "flip";
    Collision["none"] = "none";
})(Collision || (Collision = {}));
